import React, { Component, Fragment } from 'react';
import moment from 'moment';
import 'moment/locale/el'
import axios from '../request';

import GameRow from './GameRow';
import BookmakerAd from './BookmakerAd';
import DateSelect from './DateSelect';

class Body extends Component {

  bookmakerAdClientIds = [2];
  constructor(props) {
    super(props);

    this.state = {
      games: null,
      day: null
    };
  }

  componentWillReceiveProps(nextProps) {

    if( this.props.date !== nextProps.date ){

      this.setState({
        games: null // Show loader
      });

      // Pre load games
      this.fetchBody(nextProps);

    }
  }

  componentWillMount() {
    this.fetchBody();
  }

  componentWillUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  fetchBody(nextProps) {
    const clientId = this.props.clientId;
    const DATE = nextProps ? nextProps.date : this.props.date;
    const IS_STATIC = nextProps ? nextProps.isStatic : this.props.isStatic;
    const productId = this.props.productId;

    // `${config.backend}/v2/kouponi/data/${clientId}/days`;
    const URL = typeof DATE !== 'undefined' ? `/v2/kouponi/data/${clientId}/${productId}/${DATE}` : `/v2/kouponi/data/${clientId}/${productId}`;
    const _this = this;

    axios.get(URL, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then( (response) => {
      _this.setState({
        games: response.data.games,
        day: response.data.day
      }, ()=> {
        this.props.setClientStatusCallback(false);
        this.props.setTextLink(response.data && response.data.client ? response.data.client.textlink : '')
      });

      // if is live score set up a timeout everytime
      if( ! IS_STATIC ) {
        _this.timeout = setTimeout(() => {
          _this.fetchBody();
          _this.timeout = null;
        }, 12000);
      }
    })
    .catch(error => {
      if (error.response && error.response.status === 401) {
        this.props.setClientStatusCallback(true)
      }
      _this.timeout = setTimeout(() => {
        _this.fetchBody();
        _this.timeout = null;
      }, 20000);

    });
  }

  renderBookmakerAd(i) {
    // @TODO make it managable by betwidgets - kyriakos request to temporarily disable this
    return (i+1 + 10)%10 === 0 ? <BookmakerAd /> : null;
  }

  render() {
    if( ! this.state.games ) {
      return (
        <tbody ref='body'>
          <tr>
            <td colSpan="18" className="r-kouponi-loader">
              <div className="loader">
                 φορτωνει...
               </div>
            </td>
          </tr>
        </tbody>
      )
    }

    if( 'showFilter' in this.props ){

      // IE support
      if (!Array.prototype.filter) {
        // eslint-disable-next-line no-extend-native
        Array.prototype.filter = function(fun /*, thisp*/) {
          var len = this.length >>> 0;
          if (typeof fun !== "function")
          throw new TypeError();

          var res = [];
          var thisp = arguments[1];
          for (var i = 0; i < len; i++) {
            if (i in this) {
              var val = this[i]; // in case fun mutates this
              if (fun.call(thisp, val, i, this))
              res.push(val);
            }
          }
          return res;
        };
      }

    }

    var prev = null;
    var showFlag = true;

    // Initial data
    let GAMES = this.state.games;

    // Filter GAMES
    GAMES = this.state.games.filter((G) => {

      // SHOW_ALL:FILTER WILL PASS AND RETURN TRUE TO EVERITHING
      // eslint-disable-next-line default-case
      switch (this.props.showFilter) {
        case 'SHOW_ONLY_LIVE':
          return G.isLive;
        case 'SHOW_ONLY_FINISHED':
          return G.isFinished;
        case 'SHOW_ONLY_SELECTED':
          return this.props.searchSelectedId(G.id);
        case 'SHOW_EXCEPT_FINISHED':
          return !G.isFinished;
      }

      return true;

    });

    // Body
    var body_list = GAMES.map(function(obj, i){

        // Update boolean
        showFlag = prev !== obj.comp_name;

        // Renew prev value for the next circle
        prev = obj.comp_name;

        var selected = this.props.isStatic ? false : this.props.searchSelectedId(obj.id);

        return (
          <Fragment key={i}>
            <GameRow
              isExternal={this.props.isExternal}
              showFlag={showFlag}
              G={obj}
              res={this.props.res}
              selected={selected}
              onSelectGame={this.props.onSelectGame}
              soundEnabled={this.props.soundEnabled}
              isStatic={this.props.isStatic}
              key={i} />
              {this.renderBookmakerAd(i)}
          </Fragment>
        );
    }.bind(this));

    if( ! GAMES.length ){
      return (
        <tbody ref="body">
          <tr>
            <td colSpan="18" className="no_games">

              {this.props.showFilter === 'SHOW_ONLY_SELECTED' && !this.props.res.isMobilePortrait &&
              <span>
                Δεν υπάρχουν επιλεγμένα παιχνίδια. Πατήστε στο αστεράκι <i className="fa fa-star"></i> δεξιά της κάθε γραμμής για να προσθέσετε τα δικά σας παιχνίδια
              </span>}

              {this.props.showFilter === 'SHOW_ONLY_SELECTED' && this.props.res.isMobilePortrait &&
              <span>
                Δεν υπάρχουν επιλεγμένα παιχνίδια. Κάντε κλικ σε ενα παιχνίδι για να προσθεθεί στην λίστα
              </span>}

            </td>
          </tr>
        </tbody>
      )
    }

    return (
      <tbody ref="body">

        <tr>
          <td colSpan="18" className="date_header">

            {!this.props.noControls
              ? <DateSelect
                  currentDay={this.state.day}
                  dateControls={this.props.dateControls}
                  date={this.props.date}
                  onDateChange={this.props.onDateChange}
                  />
              : <span>{moment(this.props.date).format("dddd DD MMM YYYY")}</span>
            }

          </td>
        </tr>
        {body_list}
      </tbody>
    )
  }
};

export default Body



// WEBPACK FOOTER //
// ./src/Components/Body.js